/**
 * Default value to round number after decimal point
 */
export const maxDecimals = 2; // for fiat values TODO use this variable everywhere in project

export const tokenDecimalsMax = 0;
